import "./EntryBox.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const API_KEY = process.env.REACT_APP_API_URL

export function EntryBox() {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [count, setCount] = useState(0);
  const [countCategories, setCountCategories] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    fetchCategories();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_KEY}/api/apps/`);
      setCount(res?.data?.count);
      setData(res.data.apps);
    } catch (err) {
      console.error("Error fetching apps:", err.message);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API_KEY}/api/categories`);
      setCountCategories(res?.data?.count);
    } catch (err) {
      console.error("Error fetching categories:", err.message);
    }
  };

  const handleSearch = () => {
    const matchedApp = data.find(
      (app) =>
        app.category_id?.name?.toLowerCase() === searchTerm.trim().toLowerCase()
    );

    if (matchedApp) {
      const categoryName = matchedApp?.category_id?.name;

      navigate(`/category`, {
        state: { categoryName: categoryName },
      });
    } else {
      toast.error("No app found for this category.");
    }
  };

  // Unique category names for autocomplete
  const categoryOptions = [...new Set(data.map(app => app.category_id?.name))].filter(Boolean);

  return (
    <section className="text-center hero-section">
      <div className="container">
        <h1 className="fw-bolder display-5">
          Discover The Best AI Websites & Tools
        </h1>
        <p style={{fontSize:"16px"}} className="mb-4">
          <span className="text-primary fw-semibold">{count}</span> AIs and
          <span className="text-primary fw-semibold"> {countCategories} </span> categories in
          the best AI tools directory. AI tools list & GPTs store are updated daily by ChatGPT.
        </p>

        <div className="custom-search-box mx-auto mt-4">
          <div className="input-group flex-nowrap">
            <input
              type="text"
              className="form-control custom-input"
              placeholder="Search by Category, e.g. Writing & Editing"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              list="category-options"
              autoComplete="on"
            />
            <button
              className="btn custom-btn"
              type="button"
              onClick={handleSearch}
            >
              <i className="bi bi-search"></i>
            </button>
          </div>

          {/* 👇 Auto-suggestion list for input */}
          <datalist id="category-options">
            {categoryOptions.map((name, index) => (
              <option key={index} value={name} />
            ))}
          </datalist>
        </div>
      </div>
    </section>
  );
}
